import TagListByCategory from './TagListByCategory.vue';

export default {
  TagListByCategory,
};
